// Services
import watchdogClient from '@/services/WatchdogClient'

// Models
import ProfileWatchdogRules from '@/models/ProfileWatchdogRules'

export default {
  fetchProfileRules (profileId, clientTiers) {
    return watchdogClient.sendRequest(
      'GET',
      `api/v1/admin/rules/profile/${profileId}`,
      { clientTiers }
    )
  },
  updateProfileRules (profileId, data) {
    return watchdogClient.sendRequest(
      'POST',
      `api/v1/admin/rules/profile/${profileId}/edit`,
      data
    )
  }
}

export function ProfileRulesApiPayload (payload) {
  return payload.map(profileRulesData => new ProfileWatchdogRules(profileRulesData))
}
